import React, { PureComponent } from 'react';
import { history } from 'store';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import { resetSection, reset } from 'redux-form';
import { getPreviousStep, getCurrentStep } from 'store/booking/selector';
import { getAuthData } from 'store/auth/selector';
import {
  setCurrentStepAction,
  setPreviousStepAction,
} from 'store/booking/action';

import { logoutAction, logOutNotClearDataAction } from 'store/auth/action';
import { getListOnlineService } from 'store/onlineService/selector';
import { BookingFormId, ViewBookingsFormId } from 'model/booking';
import { PATHS } from 'common/enum';
import { STEP_VIEW_BOOKINGS } from 'common/enum/viewBooking';

const listSteps = {
  '1': '',
  '2': 'Service',
  '3': 'Location, Clinic',
  '4': 'Appointment',
  '5': 'Registration',
};
class Header extends PureComponent {
  handleLogin = e => {
    e.preventDefault();
    history.push(PATHS.LOGIN);
  };

  handleViewBookings = e => {
    e.preventDefault();
    history.push(PATHS.VIEW_BOOKINGS);
    window.sessionStorage.setItem('step', STEP_VIEW_BOOKINGS.VIEW);
    this.props.resetViewBookingForm();
  };

  handleLogout = e => {
    e.preventDefault();
    const { resetSection, logOut } = this.props;
    resetSection('s4', 's5');
    logOut();
  };

  _onBackButtonClick = e => {
    e.preventDefault();
    const { previousStep, setCurrentStep, setPreviousStep } = this.props;
    const newPreviousStep = update(previousStep, {
      $splice: [[previousStep.length - 1, 1]],
    });
    setCurrentStep(previousStep[previousStep.length - 1]);
    setPreviousStep(newPreviousStep);
  };

  _renderButtonViewBooking = () => {
    return (
      <a onClick={this.handleViewBookings} href={PATHS.VIEW_BOOKINGS}>
        View your booking
      </a>
    );
  };

  _renderLeftHeader = () => {
    const { currentStep, previousStep } = this.props;
    let _content = null;
    if (previousStep.length > 0 && (currentStep > 1 && currentStep < 6)) {
      const prevStepIndex = previousStep[previousStep.length - 1] + 1;
      _content = (
        <div className="uk-margin">
          <a
            className="uk-link-muted"
            href="#"
            onClick={this._onBackButtonClick}
          >
            <div className="visible-desktop">
              <span uk-icon="chevron-left" className="uk-icon"></span>
              <span className="uk-text-middle">{`Back to ${
                listSteps[prevStepIndex.toString()]
              }`}</span>
            </div>
            <div className="visible-mobile">
              <span uk-icon="chevron-left" className="uk-icon"></span>
              <span className="uk-text-middle">Prev</span>
            </div>
          </a>
        </div>
      );
    }

    return _content;
  };

  _renderRightHeader = () => {
    const { currentStep, authData } = this.props;

    let fullNamePatient = '';

    if (authData && authData.patientName) {
      fullNamePatient = authData.patientName;
    }
    let _content = null;
    if (fullNamePatient !== '') {
      _content = (
        <div className="uk-width-expand uk-text-right">
          <div className="uk-text-right">
            <div className="visible-desktop">
              <span className="uk-text-middle">{`Welcome, ${fullNamePatient}. `}</span>
              {currentStep < 5 && (
                <a onClick={this.handleLogout} href="#">
                  Logout
                </a>
              )}

              <span uk-icon="user" className="uk-text-primary"></span>
            </div>
            {currentStep < 5 && (
              <div className="visible-mobile">
                <a onClick={this.handleLogout} href="#">
                  Logout
                </a>
                <span uk-icon="user" className="uk-text-primary"></span>
              </div>
            )}
            {this._renderButtonViewBooking()}
          </div>
        </div>
      );
    } else {
      if (currentStep < 5) {
        _content = (
          <div className="uk-text-right">
            <div className="visible-desktop">
              <span className="uk-text-middle">Already a patient? </span>
              <a onClick={this.handleLogin} href={PATHS.LOGIN}>
                Login
              </a>
              <span uk-icon="user" className="uk-text-primary"></span>
            </div>
            <div className="visible-mobile">
              <a onClick={this.handleLogin} href={PATHS.LOGIN}>
                Login
              </a>
              <span uk-icon="user" className="uk-text-primary"></span>
            </div>
            {this._renderButtonViewBooking()}
          </div>
        );
      }
    }

    if (currentStep !== 6) {
      return _content;
    }
  };

  render() {
    const { listOnlineService } = this.props;
    return (
      <div>
        {listOnlineService && listOnlineService.length > 0 && (
          <div className="uk-container uk-container-small">
            <div className="uk-grid-margin uk-grid" uk-grid="">
              <div className="uk-width-expand uk-first-column">
                {this._renderLeftHeader()}
              </div>
              <div className="uk-width-expand">{this._renderRightHeader()}</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    previousStep: getPreviousStep(state),
    currentStep: getCurrentStep(state),
    authData: getAuthData(state),
    listOnlineService: getListOnlineService(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentStep: options => dispatch(setCurrentStepAction(options)),
    setPreviousStep: options => dispatch(setPreviousStepAction(options)),
    logOut: () => dispatch(logoutAction()),
    logOutNotClearData: () => dispatch(logOutNotClearDataAction()),
    resetSection: (...sections) =>
      dispatch(resetSection(BookingFormId, ...sections)),
    resetViewBookingForm: () => dispatch(reset(ViewBookingsFormId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
